import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { ADMIN_GET_TRANSFER_DETAILS } from "../../services/graphql/admin/transfers";

/**
 * Custom hook for fetching transfer details
 * @param {string} transferId - The transfer ID to fetch
 * @returns {object} Hook state and data
 */
const useAdminTransferDetail = (transferId) => {
  const [getTransferDetails, { data, loading, error, refetch }] = useLazyQuery(
    ADMIN_GET_TRANSFER_DETAILS,
    {
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    if (transferId) {
      getTransferDetails({
        variables: { transferId },
      });
    }
  }, [transferId, getTransferDetails]);

  return {
    transfer: data?.adminGetTransferDetails?.transfer,
    order: data?.adminGetTransferDetails?.order,
    business: data?.adminGetTransferDetails?.business,
    customer: data?.adminGetTransferDetails?.customer,
    statusHistory: data?.adminGetTransferDetails?.statusHistory,
    stripeTransferUrl: data?.adminGetTransferDetails?.stripeTransferUrl,
    stripeChargeUrl: data?.adminGetTransferDetails?.stripeChargeUrl,
    loading,
    error,
    refetch,
  };
};

export default useAdminTransferDetail;
